// extracted by mini-css-extract-plugin
export var desktop = "Svg-module--desktop--748db";
export var mobile = "Svg-module--mobile--fddbe";